const CHAPTER_QUESTION_ID = 908;

const CHAPTER_CATEGORY_MAP = {
    1: 'earlyChildhoodAndRoots',
    2: 'schoolYears',
    3: 'youthAndStudentYears',
    4: 'earlyAdulthood',
    5: 'startingAFamily',
    6: 'maturityAndCareer',
    7: 'goldenYears'
};

function getAnswersFromSource(currentSlide, results) {
    const answerSourceId = currentSlide.props?.answerSourceId;

    if (!answerSourceId) {
        return null;
    }

    const sourceResponse = results.userResponses.find(userResponse => userResponse.questionId === answerSourceId);

    return (currentSlide.props.answerPool || []).filter(answer => sourceResponse?.answerIds?.includes(answer.id));
}

function getChapterLabel(userResponses) {
    return userResponses.find(userResponse => userResponse.questionId === CHAPTER_QUESTION_ID)?.text;
}

function getChapterCategory(userResponses) {
    const chapterId = userResponses.find(userResponse => userResponse.questionId === CHAPTER_QUESTION_ID)?.id;

    return CHAPTER_CATEGORY_MAP[chapterId];
}

export {
    getAnswersFromSource,
    getChapterLabel,
    getChapterCategory
};
